module.exports = __webpack_public_path__ + "static/media/20200810_172209.5365fe7a.webp";